var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7456 21.3499C14.7121 21.3499 15.4956 22.1334 15.4956 23.0999V42.3499H34.7456C35.7121 42.3499 36.4956 43.1334 36.4956 44.0999C36.4956 45.0664 35.7121 45.8499 34.7456 45.8499H13.7456C12.7791 45.8499 11.9956 45.0664 11.9956 44.0999V23.0999C11.9956 22.1334 12.7791 21.3499 13.7456 21.3499Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6817 13.1639C45.3651 13.8473 45.3651 14.9553 44.6817 15.6387L14.9832 45.3373C14.2997 46.0207 13.1917 46.0207 12.5083 45.3373C11.8249 44.6539 11.8249 43.5458 12.5083 42.8624L42.2068 13.1639C42.8903 12.4805 43.9983 12.4805 44.6817 13.1639Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftDown);
export default __webpack_public_path__ + "static/media/arrow-left-down.f1254b26.svg";
export { ForwardRef as ReactComponent };